module.exports = __webpack_public_path__ + "static/media/20210320_080602742_iOS.405f141c.jpg";